/* SV 21.Sep.19 */
(function ($) {
  $(function () {
    // Reorder sizes to XS/S/M/L/XL
    var sizes = ['XS', 'S', 'M', 'L', 'XL'];
    $('[data-option-name="Size"]').each(function () {
      var $xs = $(this).find('[data-value="XS"]');
      $xs.prependTo($(this).find('.content'));
    }); 
  });
})(jQuery);
